import { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import { useXR } from "@react-three/xr";

/**
 * WebXR must advance every frame. With R3F frameloop="demand", nothing renders until invalidate().
 * Mount inside <Canvas><XR>...</XR> so useXR() is defined.
 */
export function XrInvalidateWhilePresenting() {
  const invalidate = useThree((s) => s.invalidate);
  const isPresenting = useXR((s) => s.isPresenting);

  useEffect(() => {
    if (!isPresenting) return;

    let rafId;
    let cancelled = false;
    const tick = () => {
      if (cancelled) return;
      invalidate();
      if (cancelled) return;
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);

    return () => {
      cancelled = true;
      if (rafId != null) cancelAnimationFrame(rafId);
    };
  }, [isPresenting, invalidate]);

  return null;
}
